export enum ConversationAssigneeEnum {
  AI_ASSISTANT = 'ai_assistant',
  HUMAN_OPERATOR = 'human_operator',
  UNASSIGNED = 'unassigned',
}
